import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { WhatWeDoPage } from './pages/WhatWeDoPage';
import { AboutUsPage } from './pages/AboutUsPage';
import { StrategyServicesPage } from './pages/StrategyServicesPage';
import { TeamPage } from './pages/TeamPage';
import { ContactPage } from './pages/ContactPage';
import { WhatIsMDMPage } from './pages/WhatIsMDMPage';
import { HealthcareTechnologySolutionsPage } from './pages/HealthcareTechnologySolutionsPage';
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
export function App() {
  return <BrowserRouter data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <Routes data-id="element-2">
        <Route path="/" element={<HomePage data-id="element-4" />} data-id="element-3" />
        <Route path="/what-we-do" element={<WhatWeDoPage data-id="element-6" />} data-id="element-5" />
        <Route path="/about" element={<AboutUsPage data-id="element-8" />} data-id="element-7" />
        <Route path="/services" element={<StrategyServicesPage data-id="element-10" />} data-id="element-9" />
        <Route path="/team" element={<TeamPage data-id="element-12" />} data-id="element-11" />
        <Route path="/contact" element={<ContactPage data-id="element-14" />} data-id="element-13" />
        <Route path="/what-is-mdm" element={<WhatIsMDMPage data-id="element-16" />} data-id="element-15" />
        <Route path="/healthcare-technology-solutions" element={<HealthcareTechnologySolutionsPage data-id="element-18" />} data-id="element-17" />
      </Routes>
    </BrowserRouter>;
}